module.exports = __webpack_public_path__ + "img/back-bottom-left1.c22a800b.png";